import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminLayout: React.FC = () => {
  const location = useLocation();
  const { user, logout } = useAuth();

  const isActive = (path: string) => {
    if (path === '/admin') {
      return location.pathname === '/admin';
    }
    return location.pathname.startsWith(path);
  };

  const navItems = [
    { path: '/admin', label: 'Dashboard', exact: true },
    { path: '/admin/users', label: 'Users' },
    { path: '/admin/properties', label: 'Properties' },
    { path: '/admin/bookings', label: 'Bookings' },
    { path: '/admin/waitlist', label: 'Waitlist' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex justify-between items-center h-14">
            <div className="flex items-center gap-4">
              <Link
                to="/"
                className="text-xl font-bold text-neutral-900 hover:text-neutral-700 transition-colors"
              >
                bknd
              </Link>
              <span className="px-2 py-1 text-xs font-medium bg-neutral-900 text-white rounded">
                Admin
              </span>
            </div>
            <div className="flex items-center gap-4">
              <Link
                to="/properties"
                className="text-sm text-neutral-600 hover:text-neutral-900"
              >
                Exit Admin
              </Link>
              <span className="text-sm text-neutral-600">{user?.email}</span>
              <button
                onClick={() => logout()}
                className="text-sm text-neutral-600 hover:text-neutral-900"
              >
                Sign out
              </button>
            </div>
          </div>
        </div>
      </header>

      <div className="flex">
        {/* Sidebar */}
        <aside className="w-56 bg-white border-r border-neutral-200 min-h-[calc(100vh-56px)]">
          <nav className="p-4">
            <ul className="space-y-1">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`block px-3 py-2 rounded-md text-sm ${
                      isActive(item.path)
                        ? 'bg-neutral-100 text-neutral-900 font-medium'
                        : 'text-neutral-600 hover:bg-neutral-50 hover:text-neutral-900'
                    }`}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </aside>

        {/* Main content */}
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
